import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Alert } from "antd";
import CustomerResource from "../customers/api/CustomerResource";
import { axiosErrorHandler } from "../../../../swzutils";
import { loggedInUserSelector } from "../../../../store/slice/auth";
import { userHasPermission } from "../../../../swzutils/UserPermissionsUtil";
import { useAppSelector } from "../../../../store";
const DebtorNoteAlert = ({ customerId }) => {
    const loggedInUser = useAppSelector(loggedInUserSelector);
    const [note, setNote] = useState(null);
    useEffect(() => {
        if (customerId && userHasPermission(loggedInUser, ['admin:debtor:note:view'])) {
            CustomerResource.getDebtorNote(customerId, setNote, axiosErrorHandler, () => { });
        }
        else {
            setNote(null);
        }
    }, [customerId]);
    if (!note?.note) {
        return null;
    }
    return (_jsx(Alert, { type: "info", closable: true, title: note?.debtor?.name, description: _jsx("pre", { style: { textWrap: 'wrap' }, children: note?.note }) }));
};
export default DebtorNoteAlert;
